import { useState } from "react";

/** Add drawer state of the warehouse list. Edit and detail are pages (/our-warehouse/:id), not drawers. */
export function useWarehouseActions() {
  const [drawerOpen, setDrawerOpen] = useState(false);

  return {
    drawerOpen,
    openAdd: () => setDrawerOpen(true),
    closeAll: () => setDrawerOpen(false),
  };
}
